// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lastBestPrice":"lastBestPrice_I65ti","discounted":"discounted_vvfKN"};